import { Component, Input, ViewEncapsulation } from '@angular/core';

import { EmailButtonComponent } from '../../components/email-button/email-button.component';
import { EmailLayoutComponent } from '../../components/email-layout/email-layout.component';
import { EmailLinkComponent } from '../../components/email-link/email-link.component';
import { EmailMarginComponent } from '../../components/email-margin/email-margin.component';
import { EmailMessageHeaderComponent } from '../../components/email-message-header/email-message-header.component';
import { EmailRecruiteeLogoComponent } from '../../components/email-recruitee-logo/email-recruitee-logo.component';
import { EmailTextComponent } from '../../components/email-text/email-text.component';
import { EmailMailgunIfDirective } from '../../directives/email-mailgun-if.directive';
import { SsrMarkToUnwrapDirective } from '../../directives/ssr-markto-unwrap.directive';
import { WrappedValue } from '../../mailgun/wrap-value';

@Component({
  standalone: true,
  styleUrls: ['../../global-styles.less', './candidate-shared.component.less'],
  templateUrl: './candidate-shared.component.html',
  imports: [
    EmailMarginComponent,
    EmailLayoutComponent,
    EmailRecruiteeLogoComponent,
    EmailMessageHeaderComponent,
    EmailTextComponent,
    EmailButtonComponent,
    EmailLinkComponent,
    EmailMailgunIfDirective,
  ],
  hostDirectives: [SsrMarkToUnwrapDirective],
  encapsulation: ViewEncapsulation.None,
})
export class CandidateSharedTemplateComponent {
  @Input({ required: true }) public data: WrappedValue<CandidateSharedTemplateData>;
}

export type CandidateSharedTemplateData = {
  header: string;
  avatar_url: string;
  p1_html: string;
  message_html: string;
  button_link: string;
  button_text: string;
  footer: string;
  support_email: string;
};

export const CandidateSharedTemplateMocks: CandidateSharedTemplateData[] = [
  {
    header: 'Bruno Brown shared a candidate with you',
    avatar_url: 'https://cdn3.iconfinder.com/data/icons/business-avatar-1/512/7_avatar-64.png',
    p1_html:
      'You’ve been invited to collaborate with your team member. Please log in to review the candidate’s profile.',
    message_html:
      'Please take a look at this candidate and say what you think - it’s my custom message for you.',
    button_link: 'http://recruitee.com',
    button_text: 'View candidate',
    footer: 'Need help?',
    support_email: 'support@recruitee.com',
  },
];
